import React, { useContext, useEffect, useState } from "react";
import SubMenuTitle from "../component/SubMenuTitle";
import { Col, Container, Row, Table } from "react-bootstrap";
import axios from "axios";
import CctvViewerModal from "../headoffice/modal/CctvViewerModal";
import { ProgressContext } from "../../context/Progress";

const CctvHeadManageGroupPage = () => {
  const { spinner } = useContext(ProgressContext);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [select, setSelect] = useState<any>({});
  const [selectedData, setSelectedData] = useState<any>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  /* 데이터 set */
  const fetchData = async (siteId: number) => {
    try {
      const response = await axios.post("/admin/api/cctv/retrieveCctvList", {
        siteId,
      });
      if (response.status === 200) {
        setSelectedData(response.data);
        console.log(selectedData);
        spinner.stop();
      }
    } catch (error) {
      console.error("데이터를 가져오는데 실패했습니다.", error);
    }
  };

  /* 첫 번째 데이터 setting */
  useEffect(() => {
    fetchData(3856);
  }, []);

  /* 모달 열기 (상세) */
  function openModal(data: any) {
    setSelect(data);
    setModalIsOpen(true);
  }

  return (
    <Container fluid className="bg-white px-0 bmc-txt-color-primary">
      <SubMenuTitle title={"CCTV 관리"} parentMenu={"CCTV 관리"} />
      <CctvViewerModal
        setModalIsOpen={setModalIsOpen}
        modalIsOpen={modalIsOpen}
        detailData={select}
      />

      <div
        className="p-4 overflow-y-auto"
        style={{ height: "calc(100vh - 197px)" }}
      >
        <div className="cctv-flex">
          <Row>
            <Col>
              <div className="bmc-fs-b2 my-4">
                <div>
                  <div className="align-middle cctv-tab">
                    <div
                      className={
                        activeIndex === 0 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(0);
                        fetchData(3856);
                        spinner.start();
                      }}
                    >
                      에코델타시티 24BL 민간참여 공공분양주택건립사업
                    </div>
                    <div
                      className={
                        activeIndex === 1 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(1);
                        fetchData(449);
                        spinner.start();
                      }}
                    >
                      부산 에코델타시티 3단계 2공구 조성공사
                    </div>
                    <div
                      className={
                        activeIndex === 2 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(2);
                        fetchData(3858);
                        spinner.start();
                      }}
                    >
                      부산 에코델타시티 2단계 2-1공구 조경공사
                    </div>
                    <div
                      className={
                        activeIndex === 3 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(3);
                        fetchData(3859);
                        spinner.start();
                      }}
                    >
                      부산 에코델타시티 2단계 2-2공구 조경공사
                    </div>
                    <div
                      className={
                        activeIndex === 4 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(4);
                        fetchData(3855);
                        spinner.start();
                      }}
                    >
                      센텀2지구 도시첨단산업단지 조성공사 1단계 1공구
                    </div>
                    <div
                      className={
                        activeIndex === 5 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(5);
                        fetchData(3862);
                        spinner.start();
                      }}
                    >
                      에코델타시티 11BL 민간참여 공공분양주택건립사업
                    </div>
                    <div
                      className={
                        activeIndex === 6 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(6);
                        fetchData(3873);
                        spinner.start();
                      }}
                    >
                      센텀2지구 도시첨단산업단지 조성공사 1단계 2공구
                    </div>
                    <div
                      className={
                        activeIndex === 7 ? "bmc-bg-th-cctv" : "bmc-bg-td"
                      }
                      onClick={() => {
                        setActiveIndex(7);
                        fetchData(3876);
                        spinner.start();
                      }}
                    >
                      에코델타시티 15BL 통합공공임대주택 건립사업
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <hr className="cctv-hr" />
          <div className={"ge-result"}>
            <Container fluid={true} className={"px-0"}>
              <div>
                {selectedData.length === 0 ? (
                  <Col className="text-center fs-3 mt-5">
                    등록된 CCTV가 존재하지 않습니다.
                  </Col>
                ) : (
                  <Table className="cctv-table">
                    <colgroup>
                      <col width="5%" />
                      <col width="35%" />
                      <col width="15%" />
                      <col width="10%" />
                      <col width="10%" />
                    </colgroup>
                    <thead>
                      <tr className="bmc-bg-primary">
                        <th className="text-center">연번</th>
                        <th className="text-center">현장명</th>
                        <th className="text-center">위치</th>
                        <th className="text-center">이름</th>
                        <th className="text-center">보기</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedData.map((data: any, idx: number) => (
                        <tr
                          key={idx}
                          className="border-top border-bottom fst-normal"
                        >
                          <td className="text-center">{idx + 1}</td>
                          <td className="text-center">{data.siteName}</td>
                          <td className="text-center">{data.name}</td>
                          <td className="text-center">{data.location}</td>
                          <td className="text-center">
                            <button
                              className="bmc-box-status-cctv approvaldone"
                              onClick={() => openModal(data)}
                            >
                              확인
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CctvHeadManageGroupPage;
